import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CreatableSelect from "react-select/creatable";
import searchSlice from "../features/search/search-slice";

import axios from "axios";
import CompanyCard from "../Components/Company/CompanyCard";
import {
  CartesianGrid,
  Legend,
  Line,
  LineChart,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

function Search() {
  const dispatch = useDispatch();

  const industryKW = useSelector((state) => state.search.industryKW);
  const companyKW = useSelector((state) => state.search.companyKW);
  const globalLoading = useSelector((state) => state.search.globalLoading);

  const [domain, setDomain] = useState([]);
  const [company, setCompany] = useState({});
  const [predictionYear, setPredictionYear] = useState([]);
  const [predictionPerfromance, setPredictionPerfromance] = useState([]);

  useEffect(() => {
    dispatch(searchSlice.actions.setPageNo(0));
    document.title = "SupPer - Search";
  }, []);

  const industries = [
    "retail",
    "management consulting",
    "consumer electronics",
    "electrical/electronic manufacturing",
    "food & beverages",
    "consumer goods",
    "cosmetics",
    "sporting goods",
    "supermarkets",
    "health, wellness and fitness",
    "food production",
    "packaging and containers",
    "dairy",
  ];

  const industriesArray = industries.map((industry) => ({
    value: industry,
    label: industry,
  }));

  const handleIndustryChange = (selectedOption) => {
    dispatch(searchSlice.actions.setIndustryKW(selectedOption));
    console.log(selectedOption);
  };

  const companyOptions = [
    { value: "procter & gamble", label: "procter & gamble" },
    { value: "oliver wyman", label: "oliver wyman" },
    { value: "molex", label: "molex" },
    {
      value: "melaleuca:the wellness company",
      label: "melaleuca:the wellness company",
    },
    { value: "dyson", label: "dyson" },
    { value: "lane bryant", label: "lane bryant" },
    { value: "edcon", label: "edcon" },
    { value: "hitachi", label: "hitachi" },
    { value: "gordon food service", label: "gordon food service" },
    { value: "bass pro shops", label: "bass pro shops" },
    { value: "legrand", label: "legrand" },
    { value: "new york & company", label: "new york & company" },
    { value: "sonoco", label: "sonoco" },
    { value: "liverpool", label: "liverpool" },
  ];
  const handleCompanyChange = (selectedOption) => {
    dispatch(searchSlice.actions.setCompanyKW(selectedOption));
  };

  const data = [];
  // console.log("predictionYear", predictionYear);
  // console.log("predictionPerfromance", predictionPerfromance);
  predictionYear?.map((year, index) => {
    data.push({ name: year, value: predictionPerfromance[index] });
  });

  const sendIndustrySearch = (event) => {
    event.preventDefault();
    dispatch(searchSlice.actions.setCompanyKW(null));
    console.log(industryKW);
    dispatch(searchSlice.actions.setGlobalLoading(true));
    if (industryKW?.value) {
      axios
        .post(process.env.REACT_APP_BACKEND_URL + `/domainSearch`, {
          SearchedString: industryKW?.value,
        })
        .then((response) => {
          setDomain(response.data.List);
        })
        .catch((error) => {
          console.log(error.message);
        })
        .finally(() => {
          dispatch(searchSlice.actions.setGlobalLoading(false));
        });
    }
  };

  const sendCompanySearch = (event) => {
    dispatch(searchSlice.actions.setGlobalLoading(true));
    dispatch(searchSlice.actions.setIndustryKW(null));
    event.preventDefault();
    try {
      axios
        .post(process.env.REACT_APP_BACKEND_URL + `/companySearch`, {
          SearchedString: companyKW?.value,
        })
        .then((response) => {
          setCompany(response.data);
        })
        .catch((error) => {
          console.log(error.message);
        });

      axios
        .post(process.env.REACT_APP_BACKEND_URL + `/predictionSearch`, {
          SearchedString: companyKW?.value,
        })
        .then((response) => {
          setPredictionYear(response.data?.Years);
          setPredictionPerfromance(response.data?.Performance);
        })
        .catch((error) => {
          console.log(error.message);
        });
    } catch (error) {
      console.log(error.message);
    } finally {
      dispatch(searchSlice.actions.setGlobalLoading(false));
    }
  };

  return (
    <div className="flex flex-col h-full mt-4 gap-4 mx-auto max-w-screen-xl px-4 sm:px-6 lg:px-8">
      <div className="w-full text-sm text-gray-600 text-center font-medium">
        After selecting, press Enter to search
      </div>
      <div className="flex items-center w-full p-4 border-2 border-gray-600 rounded-md">
        <form className="w-1/2 " onSubmit={sendIndustrySearch}>
          <CreatableSelect
            required
            options={industriesArray}
            onChange={handleIndustryChange}
            value={industryKW}
            isSearchable
            placeholder="Search by an industry"
            className="rounded-md p-2 mx-auto w-full"
          />
        </form>

        <form className="w-1/2" onSubmit={sendCompanySearch}>
          <CreatableSelect
            required
            options={companyOptions}
            onChange={handleCompanyChange}
            value={companyKW}
            isSearchable
            placeholder="Search by a company"
            className="rounded-md p-2 mx-auto w-full"
          />
        </form>
      </div>
      {industryKW?.value && (
        <div className="text-3xl text-white font-bold w-full text-center">
          Top 10 Companies in{" "}
          <span className="text-blue-500">{industryKW?.value}</span>
        </div>
      )}
      <div className="flex items-center w-full p-4 border-2 border-gray-600 rounded-md bg-white">
        {/* {!globalLoading && !industryKW.value && !companyKW.value && (
          <div className="flex flex-col gap-4 w-full bg-gray-50 items-center border-2 border-red-500">
            <div className="font-bold text-indigo-600 text-xl  md:text-3xl mt-32 md:mt-16">
              Please make a search to see results !
            </div>
            <img
              src="https://cdn.dribbble.com/users/1785628/screenshots/5605512/media/097297f8e21d501ba45d7ce437ed77bd.gif"
              className="w-full md:w-1/2"
            />
          </div>
        )} */}
        {globalLoading && (
          <img
            src="https://i.pinimg.com/originals/b0/45/af/b045af8a94343e3b1fdbf1576e9818b8.gif"
            className="w-1/3 mx-auto"
          />
        )}

        {!globalLoading && !companyKW?.value && industryKW?.value && (
          <div className="flex flex-wrap justify-around  w-full  p-2 md:p-4">
            {domain.map((s) => {
              return <CompanyCard supplier={s} key={s.Cost} />;
            })}
          </div>
        )}

        {!globalLoading && !industryKW?.value && companyKW?.value && (
          <section>
            <div id="main" className=" w-full h-full">
              <h1 className="font-bold text-lg pl-8">
                Top Performing year of {companyKW?.value}
              </h1>

              <div className="flex flex-wrap">
                {Object.keys(company).map((key) => {
                  if (key == "Year") {
                    return (
                      <div className="w-full md:w-1/3 p-4" key={key}>
                        <div className="bg-gradient-to-b from-green-200 to-green-100 border-b-4 border-green-600 rounded-lg shadow-xl p-5">
                          <div className="flex flex-row items-center">
                            <div className="flex-shrink pr-4">
                              <div className="rounded-full p-5 bg-green-600">
                                <i className="fa fa-wallet fa-2x fa-inverse"></i>
                              </div>
                            </div>
                            <div className="flex-1 text-right md:text-center">
                              <p className="font-bold text-2xl">
                                <span className="text-green-500">{key}: </span>
                                {company[key]}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  }
                })}
                {Object.keys(company).map((key) => {
                  if (key == "Rating") {
                    return (
                      <div className="w-full md:w-1/3 p-4" key={key}>
                        <div className="bg-gradient-to-b from-blue-200 to-blue-100 border-b-4 border-blue-600 rounded-lg shadow-xl p-5">
                          <div className="flex flex-row items-center">
                            <div className="flex-shrink pr-4">
                              <div className="rounded-full p-5 bg-blue-600">
                                <i className="fa fa-wallet fa-2x fa-inverse"></i>
                              </div>
                            </div>
                            <div className="flex-1 text-right md:text-center">
                              <p className="font-bold text-2xl">
                                <span className="text-blue-500">{key}: </span>
                                {company[key]}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  }
                })}
                {Object.keys(company).map((key) => {
                  if (key == "AvgCost") {
                    return (
                      <div className="w-full md:w-1/3 p-4" key={key}>
                        <div className="bg-gradient-to-b from-yellow-200 to-yellow-100 border-b-4 border-yellow-600 rounded-lg shadow-xl p-5">
                          <div className="flex flex-row items-center">
                            <div className="flex-shrink pr-4">
                              <div className="rounded-full p-5 bg-yellow-600">
                                <i className="fa fa-wallet fa-2x fa-inverse"></i>
                              </div>
                            </div>
                            <div className="flex-1 text-right md:text-center">
                              <p className="font-bold text-2xl">
                                <span className="text-yellow-500">
                                  Avg Cost $ :{" "}
                                </span>
                                {company[key]}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  }
                })}
                {Object.keys(company).map((key) => {
                  if (key == "Resources") {
                    return (
                      <div className="w-full md:w-1/3 p-4" key={key}>
                        <div className="bg-gradient-to-b from-orange-200 to-orange-100 border-b-4 borderorangen-600 rounded-lg shadow-xl p-5">
                          <div className="flex flex-row items-center">
                            <div className="flex-shrink pr-4">
                              <div className="rounded-full p-5 bg-orange-600">
                                <i className="fa fa-wallet fa-2x fa-inverse"></i>
                              </div>
                            </div>
                            <div className="flex-1 text-right md:text-center">
                              <p className="font-bold text-2xl">
                                <span className="text-orange-500">{key}: </span>
                                {company[key]}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  }
                })}
                {Object.keys(company).map((key) => {
                  if (key == "AverageDeliveryTime") {
                    return (
                      <div className="w-full md:w-1/3 p-4" key={key}>
                        <div className="bg-gradient-to-b from-emerald-200 to-emerald-100 border-b-4 border-emerald-600 rounded-lg shadow-xl p-5">
                          <div className="flex flex-row items-center">
                            <div className="flex-shrink pr-4">
                              <div className="rounded-full p-5 bg-emerald-600">
                                <i className="fa fa-wallet fa-2x fa-inverse"></i>
                              </div>
                            </div>
                            <div className="flex-1 text-right md:text-center">
                              <p className="font-bold text-2xl">
                                <span className="text-emerald-500">
                                  Average Delivery Time:{" "}
                                </span>
                                {company[key] + " hours"}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  }
                })}
                {Object.keys(company).map((key) => {
                  if (key == "Region") {
                    return (
                      <div className="w-full md:w-1/3 p-4" key={key}>
                        <div className="bg-gradient-to-b from-pink-200 to-pink-100 border-b-4 border-pink-600 rounded-lg shadow-xl p-5">
                          <div className="flex flex-row items-center">
                            <div className="flex-shrink pr-4">
                              <div className="rounded-full p-5 bg-pink-600">
                                <i className="fa fa-wallet fa-2x fa-inverse"></i>
                              </div>
                            </div>
                            <div className="flex-1 text-right md:text-center">
                              <p className="font-bold text-2xl">
                                <span className="text-pink-500">{key}: </span>
                                {company[key]}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  }
                })}
              </div>

              {data.length > 0 && (
                <div className="flex justify-center items-center flex-grow mt-2 w-full">
                  <div className="bg-white border-transparent rounded-lg shadow-xl p-4">
                    <h className="font-bold uppercase text-blue-900 text-center">
                      2024 prediction of {companyKW?.value}
                    </h>

                    <LineChart
                      width={800}
                      height={500}
                      data={data}
                      margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
                    >
                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis dataKey="name" />
                      <YAxis />
                      <Tooltip />
                      {/* <Legend /> */}
                      {/* <Line type="monotone" dataKey="pv" stroke="#8884d8" /> */}
                      <Line type="monotone" dataKey="value" stroke="#82ca9d" />
                    </LineChart>
                    {/* <div className="p-5 bg-white flex items-center justify-center">
                    <Link
                      href="https://plotly-predictor-graph.herokuapp.com/"
                      target="_blank"
                      rel="noreferrer"
                      className="relative inline-block px-4 py-2 font-medium group"
                    >
                      <span className="absolute inset-0 w-full h-full transition duration-200 ease-out transform translate-x-1 translate-y-1 bg-blue-500 group-hover:-translate-x-0 group-hover:-translate-y-0"></span>
                      <span className="absolute inset-0 w-full h-full bg-white border-2 border-blue-500 group-hover:bg-blue-500"></span>
                      <span className="relative text-blue-500 group-hover:text-white">
                        Predict Now
                      </span>
                    </Link>
                  </div> */}
                  </div>
                </div>
              )}
            </div>
          </section>
        )}
      </div>
    </div>
  );
}

export default Search;
